import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM18.3207 7.09539L7.09548 18.3207C8.44998 19.3733 10.1518 20 12 20C16.4183 20 20 16.4183 20 12C20 10.1518 19.3732 8.4499 18.3207 7.09539ZM11 4.06189C7.05371 4.55396 4 7.92037 4 12C4 13.8482 4.62674 15.55 5.67927 16.9045L11 11.584L11 4.06189ZM13.001 4.06201L13 9.584L16.9047 5.67941C15.7986 4.81985 14.4609 4.24424 13.001 4.06201Z" />,
  'ChartPie'
);
